import { Badge, type BadgeProps, cn } from '@seen/ui'
import type { JSX } from 'react'

export type FacesheetCardCountProps = Omit<BadgeProps, 'variant'>

export function FacesheetCardCount({
  className,
  ...delegated
}: FacesheetCardCountProps): JSX.Element {
  return (
    <Badge
      variant="secondary"
      className={cn(
        'flex min-w-6 justify-center border-none px-2 py-1',
        className
      )}
      {...delegated}
    />
  )
}
